export default "__VITE_PUBLIC_ASSET__17390716__"